import React, { useState } from "react";
import Link from "next/link";

import { Page } from "../../../payload/payload-types";
import { Button, Props as ButtonProps } from "../Button";
import classes from "./index.module.scss";
import { FiChevronDown } from "react-icons/fi";
import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";

type CMSLinkType = {
  type?: "custom" | "reference";
  url?: string;
  newTab?: boolean;
  reference?: {
    value: string | Page;
    relationTo: "pages";
  };
  label?: string;
  appearance?: ButtonProps["appearance"];
  children?: React.ReactNode | any;
  className?: string;
  navBanner?: object;
  invert?: ButtonProps["invert"];
};

export const CMSLinkMegaMenu: React.FC<CMSLinkType> = ({
  type,
  url,
  newTab,
  reference,
  label,
  appearance,
  children,
  className,
  invert,
  navBanner,
}) => {
  const href =
    type === "reference" &&
    typeof reference?.value === "object" &&
    reference.value.slug
      ? `${
          reference?.relationTo !== "pages" ? `/${reference?.relationTo}` : ""
        }/${reference.value.slug}`
      : url;
  //console.log("children", children);
  // console.log("label", label);
  //console.log("navBanner", navBanner);
  const [openSubmenus, setOpenSubmenus] = useState({});

  const toggleSubmenu = (index) => {
    setOpenSubmenus((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  if (!href) return null;

  if (!appearance) {
    const newTabProps = newTab
      ? { target: "_blank", rel: "noopener noreferrer" }
      : {};

    if (href || url) {
      return (
        <Link {...newTabProps} href={href || url} className={className}>
          {label && label}
          {children && children}
        </Link>
      );
    }
  }

  let checkHasChildren = (label) => {
    let found:boolean = false;
    children?.map((links, i) => {
      //console.log("Links", links.page.title, label);
      if (links?.page?.title === label) {
        //return <span key={i}>{links.link.label}</span>;
        found = (
          <span onClick={() => toggleSubmenu(label)}>
            {openSubmenus[label] ? (
              <RiArrowDropUpLine size={25} />
            ) : (
              <RiArrowDropDownLine size={25} />
            )}
          </span>
        );
      }
    });
    return found;
  };

  return (
    <>
      <div className={classes.navMainBtnDiv}>
        <div className={classes.parentMain}>
          <Button
            className={[className, classes.navLinkMain]
              .filter(Boolean)
              .join(" ")}
            newTab={newTab}
            href={href}
            appearance={appearance}
            label={label}
            invert={invert}
          />
          {checkHasChildren(label)}
          <div className={classes.buttonChildren}>
            <div className={classes.buttonLinks}>
              {children?.map((links, i) => {
                //console.log("Links", links.page.title, label);
                if (links?.page?.title === label) {
                  //return <span key={i}>{links.link.label}</span>;
                  let media =
                    links?.link?.reference?.value?.icon?.url ||
                    `${process.env.NEXT_PUBLIC_SERVER_URL}/assets/icons/category-default-icon.png`;
                  //console.log("icons", links?.page?.title, "||", links?.page?.icon?.url, "||", media);
                  //console.log("icons", children);
                  return (
                    <div key={i} className={classes.buttonDivSubLinks}>
                      <Button
                        className={classes.buttonSubLinks}
                        newTab={false}
                        href={`${process.env.NEXT_PUBLIC_SERVER_URL}/${links?.link?.reference?.value?.slug}`}
                        appearance={appearance}
                        label={links?.link?.label}
                        invert={invert}
                      />
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>

      <div className={classes.navMobileBtnDiv}>
        <span className={classes.labelFullDrop}>
          <Button
            className={[className, classes.navLinkMain]
              .filter(Boolean)
              .join(" ")}
            newTab={newTab}
            href={href}
            appearance={appearance}
            label={label}
            invert={invert}
          />
          {checkHasChildren(label)}
        </span>
        {openSubmenus[label] && (
          <div className={classes.buttonChildrenMobile}>
            <div className={classes.buttonLinks}>
              {children?.map((links, i) => {
                //console.log("Links", links.page.title, label);
                if (links?.page?.title === label) {
                  //return <span key={i}>{links.link.label}</span>;
                  return (
                    <Button
                      key={i}
                      className={classes.buttonSubLinksMobile}
                      newTab={false}
                      href={`${process.env.NEXT_PUBLIC_SERVER_URL}/${links?.link?.reference?.value?.slug}`}
                      appearance={appearance}
                      label={links?.link?.label}
                      invert={invert}
                    />
                  );
                }
              })}
            </div>
          </div>
        )}
      </div>
    </>
  );
};
